<script lang="ts">
	import UserCheckIcon from "@lucide/svelte/icons/user-check";
	import DollarSignIcon from "@lucide/svelte/icons/dollar-sign";
	import HandshakeIcon from "@lucide/svelte/icons/handshake";
	import HomeIcon from "@lucide/svelte/icons/home";
	import Section from "#lib/web-ui/primitives/section.svelte";
	import {
		getTemplateContext,
		cloudinaryUrl,
		cloudinarySrcset
	} from "../template-context.svelte";

	const templateContext = getTemplateContext();
</script>

<Section>
	<div class="flex flex-col gap-8 md:flex-row md:gap-12 lg:gap-16">
		<!-- Left column with heading and content -->
		<div class="flex-1">
			<h2 class="text-primary text-lg font-bold">Sell Without the Wait</h2>
			<p
				class="text-foreground mt-2 text-4xl font-semibold tracking-tight text-pretty sm:text-5xl"
			>
				Need to Sell Your House Fast?
			</p>
			<p class="text-foreground/70 mt-6 text-lg">
				Selling your home can be time-consuming, frustrating, and complicated. At
				{templateContext.siteName}, we're here to
				<span class="text-foreground font-bold">make the process smoother and quicker</span
				>, so you can move on without the usual headaches.
			</p>

			<div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 pt-4 sm:grid-cols-2">
				<div class="space-y-2">
					<div class="flex items-center gap-2">
						<UserCheckIcon class="text-primary size-4" />
						<h3 class="text font-medium">Finding the Right Agent</h3>
					</div>
					<p class=" text-gray-600">Avoid the hassle of searching for a trusted agent.</p>
				</div>
				<div class="space-y-2">
					<div class="flex items-center gap-2">
						<DollarSignIcon class="text-primary size-4" />
						<h3 class="text font-medium">Pricing Uncertainty</h3>
					</div>
					<p class=" text-gray-600">
						No need to worry about whether your home is priced correctly.
					</p>
				</div>
				<div class="space-y-2">
					<div class="flex items-center gap-2">
						<HandshakeIcon class="text-primary size-4" />
						<h3 class="text font-medium">Frustrating Negotiations</h3>
					</div>
					<p class=" text-gray-600">
						Say goodbye to back-and-forth haggling, get a clear offer upfront.
					</p>
				</div>
				<div class="space-y-2">
					<div class="flex items-center gap-2">
						<HomeIcon class="text-primary size-4" />
						<h3 class="text font-medium">Easy Scheduling</h3>
					</div>
					<p class=" text-gray-600">
						No need to coordinate showings with buyers and agents, we'll handle it all
						for you.
					</p>
				</div>
			</div>
		</div>

		<!-- Right image column - aligned with heading -->
		<div class="flex flex-1 items-start">
			<div class="h-full w-full overflow-hidden rounded-lg">
				<img
					src={cloudinaryUrl(templateContext.images.needToSell, { width: 768 })}
					srcset={`${cloudinaryUrl(templateContext.images.needToSell, { width: 412 })} 412w, ${cloudinaryUrl(templateContext.images.needToSell, { width: 640 })} 640w, ${cloudinaryUrl(templateContext.images.needToSell, { width: 768 })} 768w`}
					width="640"
					height="427"
					sizes="(max-width: 768px) 100vw, 50vw"
					alt="sell your house fast"
					loading="lazy"
				/>
			</div>
		</div>
	</div>
</Section>
